import { enumTransportationMode } from '@data-layer/enums/entry-summaries';
import { BillNumberModel, ShipmentModel } from '@data-layer/models/common';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';

/**
 * Transportation-mode rules shared by the ES details edit sidebar and the OCR quick-fix step (#13261, #13422).
 */
export class EsTransportationModeHelper {
  /** Payload that nulls a shipment's house bill (it lives on the Shipment, not on the ES). */
  public static readonly EMPTY_HOUSE_BILL: Partial<ShipmentModel> = { houseBill: { carrier: null, number: null } };

  /** House bill is not shown for Rail and Truck. */
  public static isHouseBillHidden(mode: enumTransportationMode): boolean {
    return [enumTransportationMode.RAIL, enumTransportationMode.TRUCK].includes(mode);
  }

  public static hasHouseBillValue(shipment: ShipmentModel): boolean {
    if (!shipment.houseBill) {
      return false;
    }
    const { carrier, number }: BillNumberModel = shipment.houseBill;
    return (carrier != null && carrier !== '') || (number != null && number !== '');
  }

  /**
   * Shipments still carrying a house bill although the ES mode hides it — a mode change (PUT entry-summary)
   * leaves the value in the data and every later BL save re-sends it. Empty when nothing needs cleaning.
   */
  public static getShipmentsWithStaleHouseBill(entrySummary: EntrySummaryModel): ShipmentModel[] {
    if (!EsTransportationModeHelper.isHouseBillHidden(entrySummary.transportationMode)) {
      return [];
    }
    return (entrySummary.shipments || []).filter((shipment: ShipmentModel) => EsTransportationModeHelper.hasHouseBillValue(shipment));
  }
}
